import React from "react";
import FeatureCard from "./FeatureCard";
import { features } from "../data/featuresData";

export default function FeaturesSection({ onFeatureClick }) {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-snaptrix-gray-50 via-white to-snaptrix-gray-50" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2
            id="features-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-snaptrix-gray-700 mb-4"
          >
            Everything You Need
          </h2>
          <p className="text-lg md:text-xl text-snaptrix-gray-600 max-w-2xl mx-auto">
            Powerful features designed to make cricket club social media management effortless
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <FeatureCard
              key={feature.id}
              feature={feature}
              onClick={() => onFeatureClick(feature)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
